import { types } from 'mobx-state-tree';

const BookType = types.model('BookType', {
	id: types.number,
	name: types.string,
});

export default BookType;
